import { GatsbyImage } from "gatsby-plugin-image";

import { useImageSources } from "@theme/utils/hooks/useImageSources";

import type { ThemeUIStyleObject } from "@theme/components/ThemeUi";
import type { GatsbyImageProps, ImageDataLike } from "gatsby-plugin-image";
import type { FC } from "react";

export interface GatsbyBackgroundImageProps extends Omit<GatsbyImageProps, "image" | "alt"> {
  alt?: string;
  images: (ImageDataLike | null | undefined)[];
  sx?: ThemeUIStyleObject;
  className?: string;
}

/**
 * GatsbyBackgroundImage
 *
 * Helps validate and create a fluid background image with gatsby fluid image sources
 *
 *
 * you can also pass all gatsby image props to this component
 * style, imgStyle, loading, fadeIn etc
 *
 * And lastly you can pass in theme ui sx props
 */
export const GatsbyBackgroundImage: FC<GatsbyBackgroundImageProps> = ({
  images,
  alt,
  style,
  sx,
  className,
  ...props
}) => {
  const backgroundImageSources = useImageSources(images);

  return (
    <GatsbyImage
      image={backgroundImageSources}
      className={className}
      alt={alt || ""}
      sx={{
        ...sx,
      }}
      {...(props.loading === "eager" ? { fetchpriority: "high" } : {})}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -1,
        ...style,
      }}
      {...props}
    />
  );
};
